import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { Header, Container } from 'semantic-ui-react';
var About = /*#__PURE__*/function (_React$Component) {
  _inherits(About, _React$Component);
  var _super = _createSuper(About);
  function About() {
    _classCallCheck(this, About);
    return _super.apply(this, arguments);
  }
  _createClass(About, [{
    key: "renderContainer",
    value: function renderContainer(child) {
      var _this$props = this.props,
        withContainer = _this$props.withContainer,
        centerContent = _this$props.centerContent;
      return withContainer ? /*#__PURE__*/React.createElement(Container, {
        textAlign: centerContent ? 'center' : 'left'
      }, child) : /*#__PURE__*/React.createElement("div", {
        style: centerContent ? {
          textAlign: 'center'
        } : {}
      }, child);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        header = _this$props2.header,
        content = _this$props2.content,
        headerAs = _this$props2.headerAs;
      return this.renderContainer( /*#__PURE__*/React.createElement(React.Fragment, null, header && /*#__PURE__*/React.createElement(Header, {
        as: headerAs
      }, header), /*#__PURE__*/React.createElement("p", null, content)));
    }
  }]);
  return About;
}(React.Component);
export { About as default };
About.defaultProps = {
  centerContent: false,
  headerAs: 'h1',
  header: '',
  withContainer: false
};
About.propOptions = {
  header: ['About Us', 'Our Story']
};
About.dataPropsMap = {
  header: ['business', 'about', 'index', 'title'],
  content: ['business', 'about', 'index', 'content']
};